import React from 'react';
import { useState } from 'react';
import ContenedorAnimacion from './ContenedorAnimacion';
import Accordion, {AccordionSlots, accordionClasses,} from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails, { accordionDetailsClasses,} from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import PreguntaFrecuenteTabla from '../types/PreguntaFrecuenteTabla';
import ObtenerPreguntasFrecuentes from '../functions/ObtenerPreguntasFrecuentes';
import ShadowContent from "./ShadowContent";
import { InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';


const MostrarPreguntasFrecuentes = () => {

    //const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [preguntasFrecuentes, setPreguntasFrecuentes] = useState<PreguntaFrecuenteTabla[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [filtroPreguntas, setFiltroPreguntas] = useState<string>('');
    const [expanded, setExpanded] = React.useState<string | false>('');
    const [preguntasFrecuentesFiltradas, setPreguntasFrecuentesFiltradas] = useState<PreguntaFrecuenteTabla[]>([]);

    const handleExpansion = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
      };

    const handleClear = () => {
        setFiltroPreguntas('');
    }

    React.useEffect(() => {
        const fetchPreguntasFrecuentes = async () => {
            try {
              const data = await ObtenerPreguntasFrecuentes("activas");
              setPreguntasFrecuentes(data.preguntasfrecuentes);
              setIsLoading(false);
              setError(null);
            } catch (err) {
              setError('Error al obtener las preguntas frecuentes:' + err);
              setIsLoading(false);
            }
          };
      
          fetchPreguntasFrecuentes();
    }, []);

    React.useEffect(() => {
        if (filtroPreguntas === '') {
          setPreguntasFrecuentesFiltradas(preguntasFrecuentes);
        } else {
          setPreguntasFrecuentesFiltradas(
            preguntasFrecuentes.filter((preguntaFrecuente) =>
              preguntaFrecuente.pregunta.toLowerCase().includes(filtroPreguntas.toLowerCase()) || preguntaFrecuente.respuesta.toLowerCase().includes(filtroPreguntas.toLowerCase())
            )
          );
        }
    }, [filtroPreguntas, preguntasFrecuentes]);

    if (error) return <div>{error}</div>;

    return (
        <section id="PreguntasFrecuentes" className="bg-white pt-[60px]">
            <div className="flex flex-col pt-8 pb-4 px-4 mx-auto max-w-screen-2xl text-center">
                <ContenedorAnimacion animation='slideInLeft' duration={800} delay={1} className="">
                    <div className="mx-auto max-w-screen-2xl space-y-3">
                        <h2 className="font-metropolis mb-4 text-4xl tracking-tight font-regular text-gray-900 ">Preguntas Frecuentes</h2>
                        <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Encontrá respuestas a las preguntas más frecuentes sobre nuestros servicios y beneficios.</h3>
                        <TextField
                            id="filtroPreguntas"
                            label="Buscar..."
                            variant="outlined"
                            className="w-full mt-4"
                            sx={{
                                '& .MuiOutlinedInput-input': {
                                    padding: '8px',
                                },
                                '& .MuiInputLabel-outlined': {
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0px',
                                },
                                width: '50%',
                                minWidth: '280px',
                                marginRight: '6px',
                                marginBottom: '8px',
                            }}
                            InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {filtroPreguntas && (
                                      <IconButton onClick={handleClear} edge="end">
                                        <ClearIcon />
                                      </IconButton>
                                    )}
                                  </InputAdornment>
                                ),
                              }}
                            onChange={(e) => setFiltroPreguntas(e.target.value)}
                            value={filtroPreguntas}
                         />
                    </div> 
                </ContenedorAnimacion>
            </div>
            <ContenedorAnimacion animation='slideInUp' duration={800} delay={1} className="">
                {isLoading && (
                    <div className="flex flex-col justify-center items-center h-48">
                        <CircularProgress />
                        <h3 className="font-metropolis mt-4 text-xl">Cargando Preguntas Frecuentes...</h3>
                    </div>
                )}

                {!isLoading && (
                    <div className="flex flex-col flex-grow bg-white justify-center items-center w-full space-y-3 pb-5">
                        {preguntasFrecuentesFiltradas.map((preguntaFrecuente) =>
                        <div key={preguntaFrecuente.id} className="flex flex-col w-[85%]">
                            <Accordion
                                expanded={expanded === 'panel' + preguntaFrecuente.id.toString()}
                                onChange={handleExpansion('panel' + preguntaFrecuente.id.toString())}
                                sx={[
                                    expanded === 'panel' + preguntaFrecuente.id.toString()
                                    ? {
                                        [`& .${accordionClasses.region}`]: {
                                            height: 'auto',
                                        },
                                        [`& .${accordionDetailsClasses.root}`]: {
                                            display: 'flex',
                                        },
                                    } : {
                                        [`& .${accordionClasses.region}`]: {
                                            height: 0,
                                        },
                                        [`& .${accordionDetailsClasses.root}`]: {
                                            display: 'none',
                                        },
                                    },
                                ]}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    arial-controls={"panel" + preguntaFrecuente.id.toString() + "-content"}
                                    id={"panel" + preguntaFrecuente.id.toString() + "-header"}
                                    sx={{ backgroundColor: 'rgba(0, 0, 0, .03)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, .15)',
                                        }
                                     }}
                                >
                                    <Typography>{preguntaFrecuente.pregunta}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ShadowContent htmlContent={preguntaFrecuente.respuesta} />
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        )}
                </div>)}
            </ContenedorAnimacion>
        </section>
    );
};

export default MostrarPreguntasFrecuentes;